import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { isAfter } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { isMobile } from 'react-device-detect';
import ResizeObserver from 'resize-observer-polyfill';

import './RaceEvent.scss';
import Icon from '../../Icon/Icon';
import Race from '../Race/Race';

class RaceEvent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showMoreLeft: false,
      showMoreRight: false
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.componentResized);

    this.componentResized();

    if (this.racesContainerRef && this.raceRef) {
      setTimeout(() => {
        this.racesContainerRef?.scroll(this.raceRef?.offsetLeft - this.racesContainerRef?.offsetLeft, 0);
      }, 100);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.componentResized);

    if (this.racesContainerRef) {
      this.resizeObs.unobserve(this.racesContainerRef);
    }
  }

  addRef = (el) => {
    this.racesContainerRef = el;

    if (this.racesContainerRef) {
      this.resizeObs = new ResizeObserver(this.componentResized);
      this.resizeObs.observe(this.racesContainerRef);
    }
  }

  componentResized = () => {
    this.setState({ showMoreRight: this.racesContainerRef.offsetWidth < this.racesContainerRef.scrollWidth });
  }

  onScrollHandle = () => {
    this.setState({
      showMoreLeft: this.racesContainerRef.scrollLeft !== 0,
      showMoreRight: (this.racesContainerRef.scrollWidth - this.racesContainerRef.clientWidth) !== this.racesContainerRef.scrollLeft
    });
  }

  goLeft = () => {
    const leftPos = this.racesContainerRef.scrollLeft;
    this.racesContainerRef.scroll(leftPos - 47, 0);
  }

  goRight = () => {
    const leftPos = this.racesContainerRef.scrollLeft;
    this.racesContainerRef.scroll(leftPos + 47, 0);
  }

  render() {
    const { events, selectedTimezone, meetingCode } = this.props;
    let valid = false;

    return (
      <div className="race-event__navigate-race-container">
        {
          !isMobile &&
          <div className="race-event__left-arrow-container">
            <Icon
              icon="arrow"
              className={
                classNames({
                  'race-event__left-arrow': true,
                  'race-event__left-arrow--hide': !this.state.showMoreLeft
                })
              }
              onClick={ this.goLeft }
            />
          </div>
        }
        <div className="race-event__races-container" ref={ this.addRef } onScroll={ this.onScrollHandle }>
          {
            _.map(events, racingEvent => {
              const date = utcToZonedTime(racingEvent.eventStart * 1000, selectedTimezone);

              if (isAfter(date, new Date()) && !valid) {
                valid = true;
                return <Race
                  key={ racingEvent.eventCode }
                  setRef={ el => this.raceRef = el }
                  racingEvent={ racingEvent }
                  valid={ valid }
                  meetingCode={ meetingCode }
                />;
              } else {
                return <Race key={ racingEvent.eventCode } racingEvent={ racingEvent } meetingCode={ meetingCode } />;
              }
            })
          }
        </div>
        <div>
          {
            !isMobile &&
            <Icon
              className={
                classNames({
                  'race-event__right-arrow': true,
                  'race-event__right-arrow--hide': !this.state.showMoreRight
                })
              }
              icon="arrow"
              onClick={ this.goRight }
            />
          }
        </div>
      </div>
    );
  }
}

RaceEvent.propTypes = {
  events: PropTypes.array,
  selectedTimezone: PropTypes.string,
  meetingCode: PropTypes.number
};

const mapState = state => ({
  selectedTimezone: state.odds.selectedTimezone
});

export default connect(mapState, null)(RaceEvent);
